(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torrins-cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  // Re-render this section when the cart changes (Horizon dispatches Shopify's cartLinesUpdate on remove/qty change).
  if (!window.torrinsCartRecsRefresh) {
    window.torrinsCartRecsRefresh = async () => {
      for (const wrapper of document.querySelectorAll('[data-torrins-cart-recs][data-section-id]')) {
        const sectionId = wrapper.getAttribute('data-section-id');
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', sectionId);
          const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
          if (!response.ok) continue;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = html.querySelector(`[data-torrins-cart-recs][data-section-id="${sectionId}"]`);
          if (next) wrapper.replaceWith(next);
        } catch {}
      }
    };

    import('@shopify/events')
      .then(({ StandardEvents }) => {
        document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
          const done = event.promise ?? Promise.resolve();
          done.then(window.torrinsCartRecsRefresh, window.torrinsCartRecsRefresh);
        });
      })
      .catch(() => {});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torrins-collection-filter-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadingClass = 'torrins-ftabs-loading';

    async function update(url) {
      const tabsSection = document.querySelector('[data-torrins-ftabs-section]');
      const tabsId = tabsSection?.dataset.torrinsFtabsSection;
      const mainId = document.querySelector('results-list[section-id]')?.getAttribute('section-id');
      const mainSection = mainId ? document.getElementById(`shopify-section-${mainId}`) : null;
      if (!tabsId || !mainSection) {
        window.location.assign(url);
        return;
      }

      mainSection.classList.add(loadingClass);
      try {
        const fetchUrl = new URL(url);
        fetchUrl.searchParams.set('sections', `${mainId},${tabsId}`);
        const response = await fetch(fetchUrl.toString());
        if (!response.ok) throw new Error(String(response.status));
        const sections = await response.json();

        for (const id of [mainId, tabsId]) {
          const current = document.getElementById(`shopify-section-${id}`);
          const next = new DOMParser()
            .parseFromString(sections[id] ?? '', 'text/html')
            .getElementById(`shopify-section-${id}`);
          if (!current || !next) throw new Error('missing section');
          current.innerHTML = next.innerHTML;
        }

        history.pushState({ torrinsFilterTabs: true }, '', url);
      } catch {
        window.location.assign(url);
      } finally {
        mainSection.classList.remove(loadingClass);
      }
    }

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const tab = event.target.closest('a[data-torrins-ftab]');
      if (!(tab instanceof HTMLAnchorElement) || event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();
      update(tab.href);
    });

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'sort_by') return;
      if (!input.closest('[data-torrins-ftabs-section]')) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', input.value);
      url.searchParams.delete('page');
      update(url.toString());
    });

    window.addEventListener('popstate', () => {
      if (document.querySelector('[data-torrins-ftabs-section]')) window.location.reload();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torrins-collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', async (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'sort_by') return;
    if (!input.closest('.torrins-toolbar')) return;
    input.closest('details')?.removeAttribute('open');
    const sortBy = input.value;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortBy);
    url.searchParams.delete('page');

    for (const tab of document.querySelectorAll('.torrins-toolbar__tab[data-base-url]')) {
      tab.href = `${tab.dataset.baseUrl}?sort_by=${encodeURIComponent(sortBy)}`;
    }

    const results = document.querySelector('results-list[section-id]');
    const sectionId = results?.getAttribute('section-id');
    const section = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;
    if (!section) {
      window.location.href = url.toString();
      return;
    }

    section.classList.add('torrins-toolbar-loading');
    try {
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', sectionId);
      const response = await fetch(fetchUrl.toString());
      if (!response.ok) throw new Error(String(response.status));

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextSection = html.getElementById(`shopify-section-${sectionId}`);
      if (!nextSection) throw new Error('missing section');

      section.innerHTML = nextSection.innerHTML;
      history.pushState({}, '', url.toString());
    } catch {
      window.location.href = url.toString();
    } finally {
      section.classList.remove('torrins-toolbar-loading');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torrins-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('torrins-product-tabs')) {
    class TorrinsProductTabs extends HTMLElement {
      connectedCallback() {
        this.tablist = this.querySelector('[role="tablist"]');
        this.panels = this.querySelector('[data-torrins-ptabs-panels]');
        if (!this.tablist || !this.panels) return;

        this.addEventListener('click', this.#onClick);
        this.addEventListener('keydown', this.#onKeydown);
        document.addEventListener('shopify:block:select', this.#onBlockSelect);

        this.#renderPanels();
        // Theme editor re-renders single blocks: rebuild the panels when tabs change.
        this.observer = new MutationObserver(() => this.#renderPanels());
        this.observer.observe(this.tablist, { childList: true });
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.#onBlockSelect);
        this.observer?.disconnect();
      }

      get tabs() {
        return [...this.tablist.querySelectorAll('[role="tab"]')];
      }

      #renderPanels() {
        const activeId = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true')?.dataset.tabId;
        const fragments = [...this.tablist.querySelectorAll('template[data-torrins-ptabs-panel]')].map((template) =>
          template.content.cloneNode(true)
        );
        this.panels.replaceChildren(...fragments);
        const tab = this.tabs.find((item) => item.dataset.tabId === activeId) ?? this.tabs[0];
        if (tab) this.select(tab);
      }

      select(tab, focus = false) {
        for (const other of this.tabs) {
          const active = other === tab;
          other.setAttribute('aria-selected', String(active));
          other.tabIndex = active ? 0 : -1;
          const panel = this.panels.querySelector(`#${CSS.escape(other.getAttribute('aria-controls') ?? '')}`);
          if (panel) {
            panel.dataset.active = String(active);
            panel.inert = !active;
          }
        }
        if (focus) {
          tab.focus();
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
        window.dispatchEvent(new Event('resize'));
      }

      #onClick = (event) => {
        const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
        if (tab && this.tablist.contains(tab)) this.select(tab);
      };

      #onKeydown = (event) => {
        const tabs = this.tabs;
        const index = tabs.indexOf(document.activeElement);
        if (index === -1) return;
        let next = null;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        this.select(next, true);
      };

      #onBlockSelect = (event) => {
        const tab = this.tablist.querySelector(`[data-tab-id="${event.detail?.blockId}"]`);
        if (tab) this.select(tab);
      };
    }

    customElements.define('torrins-product-tabs', TorrinsProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torrins-video-carousel"] && !Shopify.designMode) return;
  try {
    
  let productVideosSoundOn = false;

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('.product-videos__sound') : null;
    if (!button) return;

    productVideosSoundOn = !productVideosSoundOn;
    for (const toggle of document.querySelectorAll('.product-videos__sound')) {
      toggle.setAttribute('aria-pressed', String(productVideosSoundOn));
    }
    for (const video of document.querySelectorAll('.product-videos video')) {
      video.muted = !productVideosSoundOn;
    }
  });

  document.addEventListener(
    'play',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement) || !video.closest('.product-videos')) return;

      video.muted = !productVideosSoundOn;

      for (const media of document.querySelectorAll('.product-videos deferred-media[data-media-loaded]')) {
        if (media.contains(video)) continue;
        const isPlaying = [...media.querySelectorAll('video')].some((other) => !other.paused);
        if (isPlaying && typeof media.pauseMedia === 'function') media.pauseMedia();
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
